"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleStatus = exports.CircleStatusColours = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var enums_1 = require("../../enums");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var CircleStatusColours;
(function (CircleStatusColours) {
    CircleStatusColours["RED"] = "red";
    CircleStatusColours["AMBER"] = "amber";
    CircleStatusColours["GREEN"] = "green";
    CircleStatusColours["YELLOW_GREEN"] = "yellow-green";
    CircleStatusColours["BLUE"] = "blue";
    CircleStatusColours["GREY"] = "grey";
    CircleStatusColours["PURPLE"] = "purple";
    CircleStatusColours["PURPLE_1"] = "purple-1";
    CircleStatusColours["PURPLE_2"] = "purple-2";
    CircleStatusColours["PURPLE_3"] = "purple-3";
    CircleStatusColours["ORANGE"] = "orange";
    CircleStatusColours["ORANGE_1"] = "orange-1";
    CircleStatusColours["ORANGE_2"] = "orange-2";
    CircleStatusColours["ORANGE_3"] = "orange-3";
    CircleStatusColours["TEAL"] = "teal";
    CircleStatusColours["TEAL_1"] = "teal-1";
    CircleStatusColours["TEAL_2"] = "teal-2";
    CircleStatusColours["TEAL_3"] = "teal-3";
    CircleStatusColours["CORAL"] = "coral";
    CircleStatusColours["CORAL_1"] = "coral-1";
    CircleStatusColours["CORAL_2"] = "coral-2";
    CircleStatusColours["CORAL_3"] = "coral-3";
    CircleStatusColours["YELLOW"] = "yellow";
    CircleStatusColours["YELLOW_1"] = "yellow-1";
    CircleStatusColours["YELLOW_2"] = "yellow-2";
    CircleStatusColours["YELLOW_3"] = "yellow-3";
    CircleStatusColours["INDICATOR_1"] = "indicator-1";
    CircleStatusColours["INDICATOR_2"] = "indicator-2";
    CircleStatusColours["INDICATOR_3"] = "indicator-3";
})(CircleStatusColours = exports.CircleStatusColours || (exports.CircleStatusColours = {}));
var CircleStatus = function (props) {
    var colour = props.colour, isFilled = props.isFilled, size = props.size, style = props.style;
    var cls = (0, BootstrapHelper_1.B)()
        .bl("circle-status")
        .pmod(colour)
        .pmod(isFilled ? "filled" : "")
        .pmod(size || enums_1.UiSizes.MD).bem;
    return (0, jsx_runtime_1.jsx)("span", { style: style, className: "".concat(cls, " ").concat(props.className || "") });
};
exports.CircleStatus = CircleStatus;
